import WebApp from '@twa-dev/sdk';
import { request } from '../api';
import { useRootStore } from '../stores';
import { getQuizzAvailableState } from './quizz';
import { getReferralConfig } from './referral';
import { storeDidCatch } from '../utils';

export const getUserProfileInitialFlowData = async () => {
  try {
    await getQuizzAvailableState();
    await getReferralConfig();
    // TODO: find a way to fetch Game data without decreasing attempts. Probably another endpoint is necessary
  } catch (error: any) {
    console.error('Error while [getUserProfileInitialFlowData]', error);
  }
};

export const getUserProfile = async () => {
  try {
    const { setUserData } = useRootStore.getState();

    const { data: { data } = {} } = await request.get(`/users/me`);

    setUserData(data);
  } catch (error: any) {
    console.error('Error while [getUserProfile]', error);
    throw new Error();
  }
};

export const signUp = async () => {
  try {
    const { setUserData } = useRootStore.getState();

    let referralCode;

    const url = new URL(window.location.href);

    const refCodeFromUrl = url.searchParams.get('ref');

    if (refCodeFromUrl) {
      referralCode = refCodeFromUrl;
    }

    if (WebApp.initDataUnsafe?.start_param) {
      referralCode = WebApp.initDataUnsafe.start_param;
    }

    const {
      data: { data: { response } = {} },
    } = await request.post(`/users/sign_up`, {
      referralCode,
    });

    setUserData(response);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [signUp]', error);
    throw error;
  }
};

export const getUserStats = async () => {
  try {
    const { setUserStats } = useRootStore.getState();

    const {
      data: { data = {} },
    } = await request.get(`/users/stats`);

    setUserStats(data);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [getUserStats]', error);
    throw error;
  }
};

export const addSuiAddress = async (walletAddress: string) => {
  try {
    const { setWallet } = useRootStore.getState();

    await request.post(`/users/add-wallet`, {
      wallet_address: walletAddress,
    });

    setWallet(walletAddress);
  } catch (error: any) {
    storeDidCatch(error);
    console.error('Error while [addSuiAddress]', error);
    throw error;
  }
};
